import { useState, useEffect } from "react";

// third-party
import { IntlProvider } from "react-intl";
import useConfig from "hooks/useConfig";
import { getQueryVariable } from "utils";

// project imports

// load locales files
const loadLocaleData = (locale: string) => {
  const LANGS = ["ar", "de", "en", "es", "fr", "id", "it", "ja", "ko", "nl", "pl", "pt", "ru", "zh-cn", "sv", "th", "tr", "vi", "zh-tw"];

  if (LANGS.indexOf(locale.toLowerCase()) > -1) {
    return import(`utils/locales/${locale.toLowerCase()}.json`);
  }

  return import("utils/locales/en.json");
};

const getQueryVariableLang = (variable: string) => {
  const query = window.location.search.substring(1);
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    if (pair[0] == variable) {
      if (pair[1].split(/[-_]/)[1]) {
        return pair[1].split(/[-_]/)[0] + "-" + pair[1].split(/[-_]/)[1].toUpperCase();
      }

      if (pair[1] === "zh") {
        return "zh-CN";
      }

      return pair[1];
    }
  }
  return false;
};

// ==============================|| LOCALIZATION ||============================== //

interface LocalesProps {
  children: React.ReactNode;
}

const Locales = ({ children }: LocalesProps) => {
  const { locale, onChangeLocale } = useConfig();
  const mylocale = getQueryVariableLang("lang") || getQueryVariableLang("l") || locale;
  const [messages, setMessages] = useState<Record<string, string>>();
  const openid = getQueryVariable("openid");
  const properties = getQueryVariable("properties");
  const fp_uid = getQueryVariable("fp_uid");

  useEffect(() => {
    onChangeLocale(mylocale);
    loadLocaleData(mylocale).then((d) => {
      setMessages(d.default);
    });

    if (openid) {
      localStorage.setItem("koa-webtools-auth", JSON.stringify({ openid: openid }));
    }

    if (properties) {
      localStorage.setItem("properties", properties);
    }

    if (fp_uid) {
      localStorage.setItem("fp_uid", fp_uid);
    }

    const options = {
      game_id: 30001,
      game_project: "ss_global",
      lang: mylocale,
      openid: openid
    };

    window.FP = new window.FPOAuthSDK(options);
    // window.FP.updateApiUrl("https://store-account-stage.funplus.com");
    // window.FP.updateLoginUrl("https://store-funplusid-stage.funplus.com/oauth");
  }, [mylocale, openid, properties]);

  return (
    <>
      {messages && (
        <IntlProvider locale={locale} defaultLocale="en" messages={messages}>
          {children}
        </IntlProvider>
      )}
    </>
  );
};

export default Locales;
